module.exports = __webpack_public_path__ + "img/9788994475110.5820adda.jpg";